import React from 'react';
import { AlertTriangle, CheckCircle2, Info } from 'lucide-react';
import type { TipoAdvertencia } from '../../utils/reglas';
const ESTILOS: Record<TipoAdvertencia | 'ok', {
  caja: string;
  icono: React.ReactNode;
}> = {
  alerta: {
    caja: 'border-alerta/40 bg-alerta/5 text-tinta',
    icono: <AlertTriangle className="h-4 w-4 text-alerta" aria-hidden="true" data-id="element-387" data-mp="2oxeff3itu4f4" />
  },
  aviso: {
    caja: 'border-oro-oscuro/40 bg-oro/10 text-tinta',
    icono: <AlertTriangle className="h-4 w-4 text-oro-oscuro" aria-hidden="true" data-id="element-388" data-mp="2tw7uv1hoc5hx" />
  },
  info: {
    caja: 'border-vino/20 bg-vino/5 text-tinta',
    icono: <Info className="h-4 w-4 text-vino" aria-hidden="true" data-id="element-389" data-mp="33msv0tczxi2y" />
  },
  ok: {
    caja: 'border-verde/30 bg-verde/5 text-tinta',
    icono: <CheckCircle2 className="h-4 w-4 text-verde" aria-hidden="true" data-id="element-390" data-mp="38kc65keedeqo" />
  }
};
export function Aviso({
  tipo = 'info',
  titulo,
  children,
  className = ''
}: {
  tipo?: TipoAdvertencia | 'ok';
  titulo?: string;
  children?: React.ReactNode;
  className?: string;
}) {
  const estilo = ESTILOS[tipo];
  return <div className={`flex gap-3 rounded-xl border p-3 ${estilo.caja} ${className}`} role="note" data-id="element-391" data-mp="2xuhokp69aixj">
      <span className="mt-0.5 shrink-0" data-id="element-392" data-mp="2tqjl629welyo">{estilo.icono}</span>
      <div className="text-sm" data-id="element-393" data-mp="2orq98ea9f30m">
        {titulo && <p className="font-semibold text-tinta-titulo" data-id="element-394" data-mp="2osrvlewq7bxn">{titulo}</p>}
        {children && <div className="text-tinta-sec" data-id="element-395" data-mp="2ju6tf9xwyi6k">{children}</div>}
      </div>
    </div>;
}